import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from "react-router-dom";

import { inject } from '@vercel/analytics';
import AnimatedCursor from "react-animated-cursor";

import './index.css';
import App from './App';

const Root = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <BrowserRouter>
      {!isSmallScreen && (
        <AnimatedCursor
          innerSize={5}
          outerSize={36}
          color='95,95,95'
          outerAlpha={0.25}
          innerScale={0.7}
          outerScale={1.5}
          outerStyle={{ border: '1.5px solid #4A4A4A' }}
          innerStyle={{ border: '4px solid #ffffff' }}
          trailingSpeed={10}
          clickables={[
            'a', 'input[type="text"]', 'input[type="email"]', 'input[type="number"]', 'input[type="submit"]',
            'input[type="image"]', 'label[for]', 'select', 'textarea', 'button', '.link'
          ]}
        />
      )}
      <App />
    </BrowserRouter>
  );
};

ReactDOM.render(<Root />, document.getElementById('root'));
inject();
